import type { FC } from 'react';

import AuditLogs from '@zen/Audit/AuditLogs';
import { useAuditLogs } from '@zen/Audit/AuditLogsProvider/AuditLogsProvider';

const AuditLogsSlideOut: FC = () => {
  const { state: auditLogsState, closeAuditLogs } = useAuditLogs();

  return (
    <div className="absolute top-0 left-0 w-full h-full z-9999 pointer-events-none">
      <div className="pointer-events-auto">
        <AuditLogs
          isVisible={auditLogsState.isOpen}
          onClose={closeAuditLogs}
          preFilters={auditLogsState.filters}
          title={auditLogsState.title}
        />
      </div>
    </div>
  );
};

export default AuditLogsSlideOut;
